import { toJS } from 'mobx';
const mergeHeaderState = (rootStore, props) => {
    if (rootStore.propStateStore.isEmbedded) {
        return;
    }
    mergePropsState(rootStore, props);
    mergeProfileTypesState(rootStore, props);
    mergeLanguageState(rootStore, props);
    mergeLocationState(rootStore, props);
    mergeOpenSectionState(rootStore, props);
    mergeSsoState(rootStore, props);
    mergeTranslationsState(rootStore, props);
    mergeMenuItemsState(rootStore, props);
    mergeShoppingCartState(rootStore, props);
    mergeOverlayState(rootStore, props);
};
const mergePropsState = (rootStore, props) => {
    if (props.etLangPath && props.etLangPath !== rootStore.propStateStore.etLangPath) {
        rootStore.propStateStore.setEtLangPath(props.etLangPath);
    }
    if (props.ruLangPath && props.ruLangPath !== rootStore.propStateStore.ruLangPath) {
        rootStore.propStateStore.setRuLangPath(props.ruLangPath);
    }
    if (props.showEnLang !== rootStore.propStateStore.showEnLang) {
        rootStore.propStateStore.setShowEnLang(props.showEnLang);
    }
    if (props.isSSR !== rootStore.propStateStore.isSsr) {
        rootStore.propStateStore.setIsSsr(props.isSSR);
    }
    if (props.isEmbedded !== rootStore.propStateStore.isEmbedded) {
        rootStore.propStateStore.setIsEmbedded(props.isEmbedded);
    }
    if (props.forceSegment !== rootStore.propStateStore.forceSegment) {
        rootStore.propStateStore.setForceSegment(props.forceSegment);
    }
    if (props.skipContactsUpdatePrompt !== rootStore.propStateStore.skipContactsUpdatePrompt) {
        rootStore.propStateStore.setSkipContactsUpdatePrompt(props.skipContactsUpdatePrompt);
    }
    if (props.hideSSO !== rootStore.propStateStore.hideSSO) {
        rootStore.propStateStore.setHideSSO(props.hideSSO);
    }
};
const mergeProfileTypesState = (rootStore, props) => {
    if (props.profileTypes && props.profileTypes !== rootStore.profileTypeStore.profileTypes) {
        rootStore.profileTypeStore.setProfileTypes(props.profileTypes, true);
    }
};
const mergeLanguageState = (rootStore, props) => {
    if (props.lang && props.lang !== rootStore.environmentStore.lang) {
        rootStore.environmentStore.setLang(props.lang);
    }
};
const mergeLocationState = (rootStore, props) => {
    if (props.currentPath && props.currentPath !== rootStore.locationStore.currentPath) {
        rootStore.locationStore.mergeState(props.currentPath, props.customerType);
    }
    if (props.customerType && props.customerType !== (rootStore.locationStore.segment === 'era' ? 'B2C' : 'B2B')) {
        rootStore.locationStore.mergeState(props.currentPath, props.customerType);
    }
};
const mergeSsoState = (rootStore, props) => {
    mergeDisableSoftAuthState(rootStore, props);
    mergeSsoClientState(rootStore, props);
    mergeLoginOptions(rootStore, props);
};
const mergeOpenSectionState = (rootStore, props) => {
    const { openSection, setSection, setOpenSection } = rootStore.sectionStore;
    if (props.openSection !== openSection) {
        if (props.openSection === undefined || props.openSection === 'default') {
            setOpenSection('default');
        }
        else {
            if (props.openSection === null) {
                setSection(null);
                setOpenSection(null);
            }
            else {
                setSection(props.openSection);
                setOpenSection(props.openSection);
            }
        }
    }
};
const mergeSsoClientState = (rootStore, props) => {
    const { clientState, isInitialized } = rootStore.ssoStore;
    const { ssoClient, ssoClientState } = props;
    if ((ssoClient || ssoClientState) && clientState !== ssoClientState) {
        rootStore.ssoStore.setClientState(isInitialized || !!ssoClientState, toJS(ssoClientState));
    }
};
const mergeDisableSoftAuthState = (rootStore, props) => {
    const { disableSoftAuth } = props;
    if (disableSoftAuth !== rootStore.ssoStore.disableSoftAuth) {
        rootStore.ssoStore.setDisableSoftAuth(disableSoftAuth);
    }
};
const mergeLoginOptions = (rootStore, props) => {
    if (rootStore.ssoStore.loginOptions !== props.loginOptions) {
        rootStore.ssoStore.setLoginOptions(props.loginOptions);
    }
};
const mergeTranslationsState = (rootStore, props) => {
    if (props.translations && rootStore.translationsStore.translations !== props.translations) {
        rootStore.translationsStore.setTranslations(true, props.translations);
    }
};
const mergeMenuItemsState = (rootStore, props) => {
    const menu = props.menu || {
        items: props.menuItems,
    };
    if (((menu === null || menu === void 0 ? void 0 : menu.items) && rootStore.menuItemStore.menuItems !== menu.items) ||
        ((menu === null || menu === void 0 ? void 0 : menu.name) && rootStore.menuItemStore.name !== menu.name) ||
        ((menu === null || menu === void 0 ? void 0 : menu.slug) && rootStore.menuItemStore.slug !== menu.slug)) {
        rootStore.menuItemStore.setMenuFromProps({
            menu: menu,
            dealerMenuItems: toJS(props.dealerMenuItems),
        });
    }
    if (!(menu === null || menu === void 0 ? void 0 : menu.items)) {
        rootStore.menuItemStore.setProvided(false);
    }
    if (rootStore.menuItemStore.customSegment !== props.customSegment) {
        rootStore.menuItemStore.setCustomSegment(props.customSegment);
    }
};
const mergeShoppingCartState = (rootStore, props) => {
    var _a, _b;
    if ((props.shoppingCartItems || props.shoppingCartItems === 0) && rootStore.cartStore.cartItemsCount !== props.shoppingCartItems) {
        rootStore.cartStore.setCartItemsCount(props.shoppingCartItems);
    }
    rootStore.cartStore.setCartNotice((_a = props.cartProps) === null || _a === void 0 ? void 0 : _a.notice);
    rootStore.cartStore.isVatDisabled = (_b = props.cartProps) === null || _b === void 0 ? void 0 : _b.isVatDisabled;
};
const mergeOverlayState = (rootStore, props) => {
    if (rootStore.overlayNoticeStore.overlayNotices !== props.overlayNotice) {
        rootStore.overlayNoticeStore.setOverlayNotice(props.overlayNotice);
    }
};
export default mergeHeaderState;
//# sourceMappingURL=HeaderStateMergeUtil.js.map